// Feature flags — flip to true to enable a dormant feature.

// Partner-facing ticketing: the per-installation "Tickets" tab for partner
// accounts (UserType 1) — create/view/comment on their own tickets.
//
// Keep this FALSE until the backend carrying the partner ticket endpoints
// (CreatePartnerTicket / GetMyTickets / GetMyTicketDetail / UpdateMyTicket /
// GetMyInstallations) is deployed and verified in production. While false,
// partners see no Tickets tab and cannot reach the tab route; admins are
// unaffected (their ticket dashboard + tab always work).
export const PARTNER_TICKETS_ENABLED = true;
